import { gql } from "@apollo/client";
import SearchableQuerySelector from "components/shared/SearchableQuerySelector";

export const FETCH_PRODUCTS_FOR_STOCK_CATEGORY = gql`
  query FETCH_PRODUCTS_FOR_STOCK_CATEGORY(
    $q: String
    $offset: Int
    $limit: Int
    $stockCategoryId: ID
    $preferPriceListId: ID
  ) {
    products(
      productType: "normal"
      q: $q
      offset: $offset
      limit: $limit
      stockCategoryId: $stockCategoryId
      preferPriceListId: $preferPriceListId
    ) {
      total
      results {
        id
        isActive
        odooId
        odooIdInc
        number
        name
        version
        countryCodeOfOrigin
        itemsPerSet
      }
    }
  }
`;

const StockCategoryProductSelector = ({
  stockCategoryId,
  onSelect,
  onBlur,
  valueView,
  optionView,
  className = "w-full",
  disabled = false,
  autoFocus = false,
}) => {
  return (
    <SearchableQuerySelector
      query={FETCH_PRODUCTS_FOR_STOCK_CATEGORY}
      queryVariables={{
        stockCategoryId,
        limit: 100,
        offset: 0,
      }}
      buildQueryVariables={({ searchText, queryVariables }) => ({
        ...queryVariables,
        q: searchText || undefined,
      })}
      resolveOptions={(data) => data?.products?.results || []}
      optionView={optionView}
      optionKey="id"
      loadingText="Searching products..."
      emptyText="No products found"
      onSelect={onSelect}
      onBlur={onBlur}
      valueView={valueView}
      placeholder="Search by product number or name"
      className={className}
      disabled={disabled}
      fetchPolicy="network-only"
      autoFocus={autoFocus}
    />
  );
};

export default StockCategoryProductSelector;
